import { httpClient } from 'api';
import type {
	WhiteboardCreatePayload,
	WhiteboardWsTokenResponse,
	WhiteboardTemplate,
	WhiteboardTemplateSummary,
	WhiteboardApiResponse,
	WhiteboardOfflineSaveResponse,
} from 'types/Whiteboard';

export const whiteboardApi = {
	createWhiteboard: ({ sessionId, pairId, applicationId }: WhiteboardCreatePayload) =>
		httpClient.get<WhiteboardApiResponse>(`whiteboard/session/${sessionId}`, { pairId, applicationId }),
	getOrCreateWhiteboardForSession: (sessionId: number, pairId: number, applicationId: number) =>
		httpClient.get<WhiteboardApiResponse>(`whiteboard/session/${sessionId}`, { pairId, applicationId }),
	getWhiteboard: (whiteboardId: number) => httpClient.get<WhiteboardApiResponse>(`whiteboard/${whiteboardId}`),
	saveOfflineScene: (whiteboardId: number, scene: WhiteboardApiResponse['scene'], baseRevision: number) =>
		httpClient.put<WhiteboardOfflineSaveResponse>(`whiteboard/${whiteboardId}/offline-scene`, {
			scene,
			baseRevision,
		}),
	templateSummaries: () => httpClient.get<WhiteboardTemplateSummary[]>('whiteboard/templates'),
	libraryTemplates: () => httpClient.get<WhiteboardTemplate[]>('whiteboard/templates', { forLibrary: true }),
	getWhiteboardsForSession: async (sessionId: number, pairId: number, applicationId: number) => {
		const whiteboard = await whiteboardApi.getOrCreateWhiteboardForSession(sessionId, pairId, applicationId);
		return whiteboard ? [whiteboard] : [];
	},
	getPdfUrl: (whiteboardId: number) => httpClient.get<{ signedUrl: string }>(`whiteboard/${whiteboardId}/pdf`),
	getWsToken: (whiteboardId: number) =>
		httpClient.get<WhiteboardWsTokenResponse>(`whiteboard/${whiteboardId}/ws-token`),
};
